/* BaristaYOU – curated complementary products
   Uses Shopify Search & Discovery's product-reference metafield as the first layer.
   Existing collection recommendations remain as fallback to fill the rail. */
(function () {
  'use strict';
  if (window.__byCuratedUpsellInit) return;
  window.__byCuratedUpsellInit = true;

  function readData() {
    var node = document.getElementById('by-curated-upsell-data');
    if (!node) return [];
    try {
      var parsed = JSON.parse(node.textContent);
      return Array.isArray(parsed.items) ? parsed.items.filter(Boolean) : [];
    } catch (e) {
      return [];
    }
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function urlKey(value) {
    try {
      return new URL(value, window.location.origin).pathname.replace(/\/$/, '');
    } catch (e) {
      return String(value || '').replace(/\/$/, '');
    }
  }

  function createCard(item) {
    var card = document.createElement('article');
    card.className = 'up-card up-card--curated';
    card.setAttribute('data-by-curated-card', '');
    card.setAttribute('data-by-product-url', item.url || '');
    card.setAttribute('data-by-product-title', item.title || 'Produkt');
    card.setAttribute('data-by-product-type', item.productType || '');
    card.setAttribute('data-by-single-variant', item.singleVariant ? 'true' : 'false');
    card.setAttribute('data-by-variant-id', item.variantId == null ? '' : String(item.variantId));
    card.setAttribute('data-by-variant-available', item.variantAvailable ? 'true' : 'false');

    var image = item.image
      ? '<img src="' + escapeHtml(item.image) + '" alt="' + escapeHtml(item.imageAlt || item.title) + '" loading="lazy" decoding="async">'
      : '';
    var compare = item.compareAtPrice
      ? '<s>' + escapeHtml(item.compareAtPrice) + '</s>'
      : '';
    var cta = item.available
      ? '<a href="' + escapeHtml(item.url) + '" class="up-cta">Produkt ansehen</a>'
      : '<a href="' + escapeHtml(item.url) + '" class="up-cta up-cta-ghost">Anfragen</a>';

    card.innerHTML =
      '<a class="up-img-link" href="' + escapeHtml(item.url) + '" tabindex="-1" aria-hidden="true">' +
        '<div class="up-img"><span class="up-badge">BaristaYOU Auswahl</span>' + image + '</div>' +
      '</a>' +
      '<div class="up-card-body">' +
        '<p class="up-status' + (item.available ? '' : ' up-status--request') + '">' +
          '<span class="up-status-dot" aria-hidden="true"></span>' +
          (item.available ? 'Bestellbar' : 'Auf Anfrage') +
        '</p>' +
        '<p class="up-name"><a href="' + escapeHtml(item.url) + '">' + escapeHtml(item.title) + '</a></p>' +
        '<p class="up-price">' + compare + escapeHtml(item.price) + '</p>' +
        cta +
      '</div>';
    return card;
  }

  function relabelFirstChoice(section, panel) {
    var tab = section.querySelector('.up-tab.is-active') || section.querySelector('.up-tab');
    if (tab) {
      var desktop = tab.querySelector('.up-tab-label--desktop');
      var mobile = tab.querySelector('.up-tab-label--mobile');
      if (desktop) desktop.textContent = 'Für dein Setup';
      if (mobile) mobile.textContent = 'Setup';
    }
    var step = panel.querySelector('.up-step');
    var copy = panel.querySelector('.up-subtext');
    var allDesktop = panel.querySelector('.up-all-desktop');
    var allMobile = panel.querySelector('.up-all-mobile');
    if (step) step.textContent = '01 · Auswahl';
    if (copy) copy.textContent = 'Von uns passend zu deinem Produkt ausgewählt.';
    if (allDesktop) allDesktop.textContent = 'Weitere entdecken';
    if (allMobile) allMobile.textContent = 'Mehr';
    panel.setAttribute('data-by-curated-panel', '');
  }

  function enhanceSection(section, items) {
    if (!section || section.dataset.byCuratedReady === 'true' || !items.length) return;
    var panel = section.querySelector('.up-panel.is-active') || section.querySelector('.up-panel');
    var grid = panel && panel.querySelector('[data-upsell-rail]');
    if (!panel || !grid) return;
    section.dataset.byCuratedReady = 'true';

    var originalCards = Array.prototype.slice.call(grid.querySelectorAll('.up-card'));
    var targetCount = originalCards.length || Math.min(5, items.length);
    if (!targetCount) targetCount = Math.min(5, items.length);

    var curatedKeys = {};
    var selected = [];
    items.forEach(function (item) {
      if (!item || !item.url || selected.length >= targetCount) return;
      var key = urlKey(item.url);
      if (curatedKeys[key]) return;
      curatedKeys[key] = true;
      selected.push(item);
    });
    if (!selected.length) return;

    originalCards.forEach(function (card) {
      var link = card.querySelector('.up-name a, .up-img-link');
      var key = link ? urlKey(link.getAttribute('href')) : '';
      if (key && curatedKeys[key]) card.remove();
    });

    var fragment = document.createDocumentFragment();
    selected.forEach(function (item) { fragment.appendChild(createCard(item)); });
    grid.insertBefore(fragment, grid.firstChild);

    Array.prototype.slice.call(grid.querySelectorAll('.up-card')).slice(targetCount).forEach(function (card) {
      card.remove();
    });

    relabelFirstChoice(section, panel);
    try {
      document.dispatchEvent(new CustomEvent('by:curated-upsell:ready', {
        detail: { count: selected.length }
      }));
    } catch (e) {}
  }

  function init() {
    var items = readData();
    if (!items.length) return;
    document.querySelectorAll('[data-section-type="upsell-tabs"]').forEach(function (section) {
      enhanceSection(section, items);
    });
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
  if (document.readyState !== 'loading') init();
})();
